<template>
  <div class="gold-prices-container">
    <!-- زر الفتح للموبايل -->
    <button class="toggle-btn" @click="toggleMenu">
      أسعار الذهب اليوم
      <span :class="{ open: isOpen }">▶</span>
    </button>

    <!-- شريط الأسعار -->
    <div class="gold-prices-bar" :class="{ open: isOpen }">
      <div class="gold-item">
        <h4>{{ $t('gold') }} (24K)</h4>
        <p>{{ ($store.state.gold.qar_ask).toFixed(2) }}</p>
      </div>

      <div class="gold-item">
        <h4>{{ $t('gold') }} (22K)</h4>
        <p>{{ ($store.state.gold.qar_ask*(22/24)).toFixed(2) }}</p>
      </div>


    <div class="gold-item">
        <h4>{{ $t('gold') }} (21K)</h4>
        <p>{{ ($store.state.gold.qar_ask*(21/24)).toFixed(2) }}</p>
      </div>



      <div class="gold-item">
        <h4>{{ $t('gold') }} (18K)</h4>
        <p>{{ ($store.state.gold.qar_ask*(18/24)).toFixed(2) }}</p>
      </div>
       <div class="gold-item">
        <h4>{{ $t('gold') }} (14K)</h4>
        <p>{{ ($store.state.gold.qar_ask*(14/24)).toFixed(2) }}</p>
      </div>


      <div class="gold-item">
        <h4>{{ $t('ounce') }} (24K)</h4>
        <p>{{ ($store.state.gold.qar_ask* (31.10)).toFixed(2) }}</p>
      </div>

     


    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const isOpen = ref(false);

const goldPrices = ref([
  { title: "ذهب 24 عيار", price: "489.94 ريال" },
  { title: "ذهب 22 عيار", price: "449.12 ريال" },
  { title: "ذهب 21 عيار", price: "428.7 ريال" },
  { title: "ذهب 18 عيار", price: "367.46 ريال" },
  { title: "ذهب أونصة", price: "4063.3 دولار" },
  { title: "فضة أونصة", price: "49.43 دولار" },
]);

function toggleMenu() {
  isOpen.value = !isOpen.value;
}
</script>

<style scoped>
.gold-prices-container {
  direction: rtl;
  font-family: "Cairo", sans-serif;
}

/* زر الطي للموبايل */
.toggle-btn {
  display: none;
  background: #111;
  color: #fff;
  border: none;
  width: 100%;
  padding: 10px 14px;
  font-size: 16px;
  text-align: right;
  cursor: pointer;
}
.toggle-btn span {
  float: left;
  transition: transform 0.3s ease;
}
.toggle-btn span.open {
  transform: rotate(90deg);
}

/* الشريط الرئيسي */
.gold-prices-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  background: #111;
  color: #fff;
  padding: 8px;
}

.gold-item {
  border-left: 1px solid #333;
  padding: 6px 12px;
  text-align: center;
  flex: 1;
  min-width: 120px;
}
.gold-item:last-child {
  border-left: none;
}
.gold-item h4 {
  margin: 0;
  font-size: 14px;
  color: #f0b400;
}
.gold-item p {
  margin: 2px 0 0;
  font-size: 13px;
  color: #ddd;
}

/* ريسبونسيف للموبايل */
@media (max-width: 768px) {
  .toggle-btn {
    display: block;
  }

  .gold-prices-bar {
    display: none;
    flex-direction: column;
  }

  .gold-prices-bar.open {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }

  .gold-item {
    border: 1px solid #333;
    border-left: none;
  }
}
</style>
